export const getFilterInitialState = ({
  searchText,
  serviceCounty,
  serviceItem,
  serviceClassificationFilter,
}) => {
  const filterState = {}
  if (searchText) {
    filterState.name = searchText
  }
  if (serviceCounty) {
    filterState.serviceCounty = serviceCounty
  }
  if (serviceItem) {
    filterState.serviceItem = serviceItem
  }
  if (serviceClassificationFilter) {
    filterState.serviceClassificationName = serviceClassificationFilter?.name
  }
  return filterState
}

export const filterReducer = (state, action) => {
  switch (action.type) {
    case 'SET_SERVICE_ITEM':
      return { ...state, serviceItem: action.payload }

    case 'SET_SERVICE_CLASSIFICATION_NAME':
      return { ...state, serviceClassificationName: action.payload }

    case 'SET_FILTER_NAME':
      return action.payload?.length
        ? { ...state, name: action.payload }
        : { ...state }

    case 'SET_SERVICE_COUNTY':
      return { ...state, serviceCounty: action.payload }

    // case 'SET_CUSTOMER_BUDGET':
    //   return action.payload?.length || action.payload === 0
    //     ? { ...state, customerBudget: parseFloat(action.payload) }
    //     : { ...state }

    // case 'TOGGLE_ADVANCED_FILTER_ITEM': {
    //   const id = action.payload
    //   const isExist = state.advancedFilterItems?.includes(id)
    //   const updatedItems = isExist
    //     ? state.advancedFilterItems.filter((itemId) => itemId !== id)
    //     : [...(state.advancedFilterItems || []), id]
    //   return { ...state, advancedFilterItems: updatedItems }
    // }

    case 'REMOVE_SERVICE_ITEM': {
      const { serviceItem, ...rest } = state
      return rest
    }

    case 'REMOVE_SERVICE_CLASSIFICATION_NAME': {
      const { serviceClassificationName, ...rest } = state
      return rest
    }

    case 'REMOVE_FILTER_NAME': {
      const { name, ...rest } = state
      return rest
    }

    case 'REMOVE_SERVICE_COUNTY': {
      const { serviceCounty, ...rest } = state
      return rest
    }

    // case 'REMOVE_CUSTOMER_BUDGET': {
    //   const { customerBudget, ...rest } = state
    //   return rest
    // }

    case 'REMOVE_ADVANCED_FILTER_ITEM': {
      const updatedItems = state.advancedFilterItems.filter(
        (item) => item !== action.payload
      )
      return { ...state, advancedFilterItems: updatedItems }
    }

    // case 'REMOVE_ALL_ADVANCED_FILTERS': {
    //   const { name, advancedFilterItems, ...rest } = state
    //   return rest
    // }

    // case 'REPLACE_ADVANCE_FILTER_FIELDS': {
    //   const { name, advancedFilterItems } = action.payload
    //   return { ...state, name, advancedFilterItems }
    // }

    case 'REPLACE_ALL':
      return action.payload

    // --- 預設情況 ---
    default:
      throw new Error('filterReducer: UNEXPECTED_ACTION')
  }
}
